module.exports = __webpack_public_path__ + "static/media/v1.f9655291.png";